import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigurarAgendaComponent } from './configurar-agenda.component';



@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ConfigurarAgendaComponent }
    ])],
    exports: [RouterModule]
})
export class ConfigurarAgendaRoutingModule { }
